<div class="page" id="top">

	<app-navbar />
	<main id="main-error">

		<div class="container">
			<h2>ERRO 404</h2>
			<p>A página que você tentou acessar não existe.<br/>Pode ser que tenha morrido.</p>
			<img src="/assets/images/mascot.png" alt="Bolão Pé na Cova" class="mascot" />
		</div>
		
	</main>
	<app-footer />
</div>
